<div class="bot-order" *ngIf="!showPrevious && !showLoaderPage">
  <div class="bot_preview_between" *ngIf="!startBot">
    <div>
      <div class="bot-order-head">
        <h4>Preview Bot</h4>
        <button class="bot-clear" (click)="handlePrevious()" [disabled]="isSubmitting">
          <img src="assets/images/botclear.svg" alt="close" title="close" />
        </button>
      </div>
      <div class="bot_preview_box_wrapper">
        <div>
          <div class="bot_preview_box">
            <!-- <div>
              <span>Exchange</span><span class="border_line"></span><span>Binance</span>
            </div> -->
            <div>
              <span>Total Open Pairs</span><span class="border_line"></span><span>{{botDetails.totalBots}}</span>
            </div>
            <div>
              <span>Investment</span><span class="border_line"></span><span>{{botDetails?.investment}}
                {{botDetails?.secondCurrencySymbol}}</span>
            </div>
            <div>
              <span>Profit currency</span><span
                class="border_line"></span><span>{{botDetails?.secondCurrencySymbol}}</span>
            </div>
          </div>
        </div>
        <!-- <div>
          <div class="bot_preview_box">
            <div>
              <span>Sell orders</span><span class="border_line"></span><span>2.52 LDO</span>
            </div>
            <div>
              <span>Buy orders</span><span class="border_line"></span><span>23.937 USDT</span>
            </div>
          </div>
        </div> -->
        <!-- <div>
          <div class="bot_preview_box">
            <div>
              <span>Buy Investment %</span><span class="border_line"></span><span>{{botDetails?.buyPercentage}}</span>
            </div>
            <div>
              <span>Buy Count</span><span class="border_line"></span><span>{{botDetails?.buyCount}}</span>
            </div>
            <div>
              <span>Sell Investment %</span><span class="border_line"></span><span>{{botDetails?.sellPercentage}}</span>
            </div>
            <div>
              <span>Sell Count</span><span class="border_line"></span><span>{{botDetails?.sellCount}}</span>
            </div>
            <div>
              <span>Profit %</span><span class="border_line"></span><span>{{botDetails?.profitPercentage}}</span>
            </div>
            <div>
              <span>Buy %</span><span class="border_line"></span><span>{{botDetails?.buyProfitPercentage}}</span>
            </div>
          </div>
        </div> -->
        <div>
          <div class="bot_preview_box">
            <div>
              <span>Order size currency</span><span
                class="border_line"></span><span>{{botDetails?.secondCurrencySymbol}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bgcolor d-flex align-items-center gap-2">
      <button class="" (click)="handlePrevious()" [disabled]="isSubmitting">
        <img src="../../../../assets/images/left_arrow.png" alt="Icon" class="img-fluid left_arrow" />
      </button>
      <button class="continue" [disabled]="isSubmitting" (click)="submitForm(orderPlaceDet)"><span>
          <span *ngIf="canStartBot"> {{ isSubmitting ? 'Processing...' : 'Start Bot' }}</span>
        </span>
      </button>

      <div>
        <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
          style="width: 70%">
          <span class="sr-only">70% Complete</span>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="create-bot-head" *ngIf="showLoaderPage">
  <div class="bot-order-head">
    <h4>Create Bot</h4>
  </div>
  <div class="create-bot">
    <img src="../../../../assets/images/startup.png" alt="start" title="start" width="100px" />
    <!-- <img
        src="../../../../assets/images/completed.png"
        alt="start"
        title="start"
      /> -->
    <h6>Starting Up</h6>
    <p>Loading......</p>
    <div class="progress">
      <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="loaderPercentage" aria-valuemin="0"
        aria-valuemax="100" [style.width.%]="loaderPercentage">
        <span class="sr-only">{{ loaderPercentage }}% Complete</span>
      </div>

    </div>
  </div>
</div>